'use strict';

let formValidation = require('../components/formValidation');
let createErrorNotification = require('../components/errorNotification');

/**
 * 
 * @param {FormElement} form 
 * @param {*} e 
 * @returns 
 */

 function getOTPData () {
  if (window.hasOwnProperty('OTPResource')) {
    return {
      sendURL: window.OTPResource.urls.send,
      verifyURL: window.OTPResource.urls.verify,
      sendTitleEmail: window.OTPResource.messages.sendTitleEmail,
      sendTitlePhone:  window.OTPResource.messages.sendTitlePhone,
      sendBtnSubmit: window.OTPResource.messages.sendBtnSubmit,
      sendNewOTP: window.OTPResource.messages.sendNewOTP,
      verifySuccessTitle: window.OTPResource.messages.verifySuccessTitle,
      verifyErrorTitle: window.OTPResource.messages.verifyErrorTitle,
      genericError: window.OTPResource.messages.verifyErrorTitle,
      resendOTP: window.OTPResource.messages.resendOTPMessage
    }
  } else {
    throw 'OTP Error: Not been included _tags/otp-resources.isml inside of _tags/main-head'; 
  }
};

let currentPinId = null;

function UpdatePinId(newPinId) {
  if (newPinId !== undefined) {
    currentPinId = newPinId;
  }
  return currentPinId;
}

function OTPSuccess () {
  var OTPData = getOTPData();
  $('#OTP-Verify-Form').html(`<div class="success">${OTPData.verifySuccessTitle}</div>`);
};

function OTPDestroy () {
  window.onRecaptchaExpired();
  $('#OTP-Container').remove();

};

function OTPSend (data) {
  var OTPData = getOTPData();
  $('#OTP-Verify-Form').find('input[name="otp"]').val('');
  $('#OTP-Verify-Form').find('.message-error').html('');
  return $.post({
    url: OTPData.sendURL,
    data: JSON.stringify({ data }),
    dataType: 'json',
    contentType: 'application/json',
    success: function (data) {
      if (data.send) {
        var OTPForm = $('#OTP-Verify-Form');
        UpdatePinId(data.pinId);
        const msg = OTPForm.data('success');
        OTPForm.append('<div class="alert edit-profile-alert alert-success card-custom text-center" role="alert">' + msg + '</div>');
        setTimeout(function () {
          $('.edit-profile-alert').remove();
        }, 5000);
      }
    }
  });
};

function SubmitVerify (dataField, e) {
  var OTPData = getOTPData();
  let form = $('#OTP-Verify-Form');
  dataField.pinId = UpdatePinId();
  var body = { 
    otp: $('#OTP-Verify-Form').find('input[name="otp"]').val(),
    data: dataField
  }
  let url = form.attr('action');  //OTP-Verify
  $.post({
    url: url,
    type: 'post',
    dataType: 'json',
    data: body,
    success: function (data) {
      window.$.spinner().stop();
      if (!data.valid) {
        $('body').trigger('otp:send:error', data);
        $('#OTP-Verify-Form').find('.message-error').html(OTPData.verifyErrorTitle);
        return false;
      } else {
        $('body').trigger('otp:send:success', data);
        OTPSuccess()
        $('#registration-form-otpcheck').val(true);
        $('form.registration button').click();
        setTimeout(() => {
          OTPDestroy();
        }, 1200)
      }
    },
    error: function (err) {
      $('body').trigger('otp:send:error', err);
      $('#OTP-Verify-Form').find('.message-error').html(OTPData.genericError);
      window.$.spinner().stop();
      return false; 
    },
  });
};

function Execute_Registration (form, e) {
  let url = form.attr('action');
  
  window.$.spinner().start();
  
  $('form.registration').trigger('login:register', e);
  
  $.ajax({
    url: url,
    type: 'post',
    dataType: 'json',
    data: form.serialize(),
    success: function (data) {
      window.$.spinner().stop();
      if (!data.success) {
        $('form.registration').trigger('login:register:error', data);
        formValidation(form, data);
        window.onRecaptchaExpired();
        if (data.reCaptchaError) {
          formValidation(form, data);
          window.onRecaptchaExpired();
        }
      } else {
        if (data.requireOTP){
          var OTPData = getOTPData();
          currentPinId = data.pinId;
          var dataField = {
           field: data.type,
           pinId: data.pinId,
           token: data.token
          }
          var Form = `
          <form id="OTP-Verify-Form" action="${OTPData.verifyURL}" data-success="${OTPData.resendOTP}" method="POST">
            <div class="title-otp">${data.type == 'phone' ? OTPData.sendTitlePhone : OTPData.sendTitleEmail}</div>
            <div>${data.text}</div>
            <input name="otp" class="" required />
            <button type="submit" class="btn btn-secondary">${OTPData.sendBtnSubmit}</button>
            <div class="message-error"></div>
            <div class="retry-OTP">${OTPData.sendNewOTP}</div>
          </form>
        `
          var container = $(document.createElement('div'));
          container.attr('id', 'OTP-Container')
              .attr('class', 'OTP-Modal')
              .html(Form);
          container.find('form').on('submit', (e) => SubmitVerify(dataField, e));
          container.find('form').find('.retry-OTP').on('click', () => OTPSend(dataField));
          $('body').append(container);
        }else {
          if ($('form.registration').hasClass('subscription') && $('#iHaveCoinCardChoice').val() === 'true' && $('#registration-form-otpcheck').val() === 'false') {
              $('#registration-form-otpcheck').val(true);
              $('form.registration button').click();
          } else {
              $('form.registration').trigger('login:register:success', data);
              location.href = data.redirectUrl;
          }
        }
      }
    },
    error: function (err) {
      if (err.hasOwnProperty('responseJSON') && err.responseJSON.hasOwnProperty('redirectUrl')) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
      }
      window.$.spinner().stop();
      window.onRecaptchaExpired();
    },
  });
  return false;
};

module.exports = {

  register: function () {

    $('#newsletterFlag').change(function(e){
      if ($(e.currentTarget).is(':checked')) {
        $('#marketing-1').click();
      }
    });
    
    $('#marketing-2').on('click.false', function(){
      $('#newsletterFlag').prop('checked', false);
    });

    $('form.registration').on('bouncerFormValid', function (e) {
      e.preventDefault();
      const form = $(this);
      const email = form.find('#registration-form-email').val();
      const target = $('section.account-content').length ? 'section.account-content' : null;
      Execute_Registration(form, e);
    });
  },

  login: function () {

    $('form.login').on('bouncerFormValid', function (e) {
      let form = $(this);
      e.preventDefault();
      let url = form.attr('action');
      window.$.spinner().start();
      $('form.login').trigger('login:submit', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          window.$.spinner().stop();
          if (!data.success) {
            formValidation(form, data);
            $('form.login').trigger('login:error', data);
          } else {
            $('form.login').trigger('login:success', data);
            location.href = data.redirectUrl;
          }
        },
        error: function (data) {
          if (data.responseJSON && data.responseJSON.redirectUrl) {
            window.location.href = data.responseJSON.redirectUrl;
          } else {
            $('form.login').trigger('login:error', data);
            window.$.spinner().stop();
          }
        },
      });
      return false;
    });

  },

  guestCheckout: function () {

    $('form.guest').submit(function (e) {
      let form = $(this);
      e.preventDefault();
      let url = form.attr('action');
      $('form.guest').trigger('guest:submit', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          if (!data.success) {
            formValidation(form, data);
            $('form.guest').trigger('guest:error', data);
          } else {
            $('form.guest').trigger('guest:success', data);
            data.trackLabel = 'guest_method';
            // $(window).trigger(customEvent.CHECKOUT.LOGIN, data);
            if (data.redirectUrl) {
              location.href = data.redirectUrl;
            } else {
            }
          }
        },
        error: function (data) {
          if (data.responseJSON.redirectUrl) {
            window.location.href = data.responseJSON.redirectUrl;
          } else {
            $('form.guest').trigger('guest:error', data);
          }
        },
      });
    });

  },

  closeModalOTP: function () {
    $(document).mouseup(function(e){
      var container = $("#OTP-Verify-Form");
   
      if(container.length >0 && !container.is(e.target) && container.has(e.target).length === 0){
          OTPDestroy();
      }
    });
  },

  resetPassword: function () {

    $('.reset-password-form').submit(function (e) {
      let form = $(this);
      e.preventDefault();
      let url = form.attr('action');
      window.$.spinner().start();
      $('.reset-password-form').trigger('login:register', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          window.$.spinner().stop();
          if (!data.success) {
            formValidation(form, data);
          } else {
            $('.request-password-body')
              .empty()
              .append('<p class="request-password-success-header">' + data.receivedMsgHeading + '</p>')
              .append('<p class="request-password-success-body">' + data.receivedMsgBody + '</p>');
            if (!data.mobile) {
              $('#submitEmailButton').text(data.buttonText).attr('modal-close', '');
            } else {
              $('.send-email-btn')
                .empty()
                .html('<a href="' + data.returnUrl + '" class="btn btn-primary btn-block">' + data.buttonText + '</a>');
            }
          }
        },
        error: function () {
          window.$.spinner().stop();
        },
      });
      return false;
    });

  },

  clearResetForm: function () {
    $('#login .modal').on('hidden.bs.modal', function () {
      $('#reset-password-email').val('');
      $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
    });
  },

  trackOrder: function () {
    $('.trackorder').on('bouncerFormValid', function (e) {
      $(this).trigger('submit');
    });
  }
};
